import React, { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import { Form, FormActions, FormFields, FormTextField, Stack } from "sprint-common-web";

import { useCloneMuxSpecificationForm } from "./useCloneMuxSpecificationForm";

export interface CloneMuxSpecificationFormProps {
    itemId: string;
    onCancel(): void;
    onSubmit(): void;
}

export interface CloneMuxSpecificationFormInputs {
    name: string;
}

export const CloneMuxSpecificationForm: FunctionComponent<CloneMuxSpecificationFormProps> = (
    props: CloneMuxSpecificationFormProps
) => {
    const { itemId, onCancel, onSubmit } = props;
    const { cloneMuxSpecification } = useCloneMuxSpecificationForm();

    const { errors, formState, control, reset, handleSubmit } = useForm<CloneMuxSpecificationFormInputs>({
        defaultValues: {
            name: ""
        },
        criteriaMode: "all"
    });

    const handleCloneMuxSpecification = async (inputs: CloneMuxSpecificationFormInputs) => {
        await cloneMuxSpecification(itemId, inputs);
        onSubmit();
        reset();
    };

    const handleCancelButtonClick = () => {
        reset();
        onCancel();
    };

    return (
        <Form onSubmit={handleSubmit(handleCloneMuxSpecification)}>
            <Stack verticalAlign="space-between">
                <FormFields>
                    <FormTextField
                        label="Name"
                        control={control}
                        name="name"
                        errors={errors}
                        rules={{
                            required: "Name is required field"
                        }}
                    />
                </FormFields>
                <FormActions
                    isLoading={formState.isSubmitting || formState.isValidating}
                    onCancel={handleCancelButtonClick}
                />
            </Stack>
        </Form>
    );
};
